// eslint-disable-next-line import/prefer-default-export
export const muiAccordionDetailsComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      marginTop: theme.spacing('1XL'),
    }),
  },
};
